import {createBrowserRouter, Navigate} from "react-router";
import Home from "../components/home/Home";
import Layout from "../Layout";
import {PATH} from "./routes";
import Team from "../components/team/Team";
import Child from "../components/child/Child";
import Senior from "../components/senior/Senior";
import Contact from "../components/contact/Contact";
import Rent from "../components/rent/Rent";
import Funds from "../components/funds/Funds";
import SeniorTrip from "../components/senior/SeniorTrip";
import PageWithCover from "../PageWithCover";

export const router = createBrowserRouter([
    {
        element: <Layout/>,
        children: [
            {path: PATH.HOME, element: <PageWithCover><Home/></PageWithCover>},
            {path: PATH.CHILD, element: <PageWithCover><Child/></PageWithCover>},
            {path: PATH.SENIOR, element: <PageWithCover><Senior/></PageWithCover>},
            {path: PATH.FUNDS, element: <PageWithCover><Funds/></PageWithCover>},
            {path: PATH.TEAM, element: <PageWithCover><Team/></PageWithCover>},
            {path: PATH.CONTACT, element: <PageWithCover><Contact/></PageWithCover>},
            {path: PATH.RENT, element: <PageWithCover><Rent/></PageWithCover>},
            {path: PATH.SENIOR_TRIP, element: <PageWithCover><SeniorTrip/></PageWithCover>},
            {path: "*", element: <Navigate to={PATH.HOME} replace/>}
        ],
    },
]);